import React from 'react';
import Navigation from '../navigation';
import ImageUploader from '../image-uploader';
import Card from './card';

export default class Ideas extends React.Component {

    state = {
        title: '',
        content: '',
        pageState: 'normal',
        featureImgUrl: null,
        uploadInProgress: false,
    };

    componentDidMount() {
        const { account } = this.props;
        const { users } = account;
        if (!account.email) {
            this.props.getAccount();
        }
        if (this.props.ideas === null) {
            this.props.getIdeas();
        }
    }

    _hasLikedPost(likes) {
        const { account } = this.props;
        return Boolean(likes.find(like => like.user === account._id));
    }

    _getPostLike(likes) {
        const { account } = this.props;
        const like = likes.find(like => like.user === account._id);
        return like._id;
    }

    handleSubmit() {
        const { title, content } = this.state;
        if (title !== '' && content !== '') {
            this.props.createIdea(this.state);
            this.setState({ pageState: 'normal' });
        }
    }

    updateFeatureImg(url) {
        this.setState({ featureImgUrl: url, uploadInProgress: false });
    }

    render() {
        const { ideas } = this.props;
        const { pageState, uploadInProgress, featureImgUrl } = this.state;
        return (
            <div>
                <Navigation {...this.props} />
                <div
                    className="px-8 py-12 relative"
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${require('../../assets/bg-1.jpg')})` }}>
                    <div className="bg-gradient-black-to-transparent"></div>
                    <div className="text-center">
                        <h2 className="relative text-center text-2xl lg:text-4xl text-white font-bold">DOING BETTER TOGETHER.</h2>
                        <p className="relative text-white text-lg lg:text-2xl text-center max-w-6xl mx-auto">Here on our IDEA Board, we encourage all of our West Cancer Center &amp; Research Institute family members to share your own ideas! Whether it&rsquo;s to make our workplace more fun or to improve clinical or administrative processes &mdash; we want to hear from you!</p>
                        <p className="relative text-white text-lg lg:text-2xl text-center max-w-6xl mx-auto">Click the green "New Idea" button on your screen to spark a change!</p>
                        {pageState === 'normal' &&
                            <button
                                className="font-bold relative mt-8 p-4 bg-west-green hover:bg-west-green-400 hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                                onClick={() => this.setState({ pageState: 'new' })}>New idea</button>
                        }
                    </div>
                </div>
                <div className="min-h-screen bg-gray-200 p-4">
                    {pageState === 'normal' && Boolean(ideas) &&
                        <div>
                            <div className="w-full flex flex-wrap">
                                {ideas.map(idea => (
                                    <Card
                                        {...this.props}
                                        key={idea._id}
                                        removeIdeaLike={() => this.props.removeIdeaLike(idea._id, this._getPostLike(idea.likes))}
                                        likeIdea={() => this.props.likeIdea(idea._id)}
                                        iLike={() => this._hasLikedPost(idea.likes)}
                                        idea={idea} />
                                ))}
                            </div>
                        </div>
                    }
                    {pageState === 'new' &&
                        <div className="max-w-3xl mx-auto">
                            <div className="max-w-xs mx-auto mb-8">
                                {Boolean(featureImgUrl) ?
                                    <img src={featureImgUrl} alt=""/>
                                    :
                                    <ImageUploader
                                        beginUpload={() => this.setState({ uploadInProgress: true })}
                                        updateFeatureImg={url => this.updateFeatureImg(url)} {...this.props} />
                                }
                            </div>
                            <label className="block font-semibold text-gray-700" htmlFor="title">Idea name</label>
                            <input
                                name="title"
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                type="text"
                                placeholder="Idea name"
                                onChange={e => this.setState({ title: e.target.value })}/>
                            <label className="mt-6 block font-semibold text-gray-700" htmlFor="details">Idea details</label>
                            <textarea
                                name="details"
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                placeholder="Tell us about your idea.."
                                rows="6"
                                onChange={e => this.setState({ content: e.target.value })}></textarea>
                            <button
                                className="p-4 text-gray-700 bg-transparent items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
                                onClick={() => this.setState({ pageState: 'normal' })}>Cancel</button>
                            <button
                                disabled={uploadInProgress}
                                className={`mt-4 p-4 ${uploadInProgress ? 'bg-gray-600 cursor-not-allowed' : 'bg-west-green hover:bg-west-green-400'} items-center text-white leading-none lg:rounded-full flex lg:inline-flex`}
                                onClick={() => this.handleSubmit()}>{uploadInProgress ? 'Upload in progress..' : 'Submit idea'}</button>
                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ideas/index.js